import React from 'react';

export const CrossInCircleIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <g>
            <path
                d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
                stroke="currentColor"
            />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.925 8.159a.542.542 0 00-.766.766l3.408 3.408-3.408 3.409a.542.542 0 10.766.766l3.408-3.409 3.409 3.409a.542.542 0 00.766-.766l-3.409-3.409 3.409-3.408a.542.542 0 00-.766-.766l-3.409 3.408L8.925 8.16z"
            fill="currentColor"
        />
    </svg>
);
